import React from "react";
import { Formik, Field, Form } from "formik";
import {
    FieldWrappers,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
} from "../Styles/InputStyle2";
import { Select, MenuItem, Menu } from "@mui/material";
import { FaUserPlus } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import * as Yup from "yup";

const MaintenanceWarranty = ({ stepOneData, setSelectedForm,setFormData,formData,addAssetFunctionMutate }) => {
    const initialValues = {
        expiryDate: "",
        maintenanceDate: "",
        scheduleMaintenanceDate: "",
        notes: "",
        assignVendor: "",

    };
    const validationSchema = Yup.object({
        expiryDate: Yup.date().required("Enter Expiry Date"),
    });
    const vendorList = [
        { id: "1", name: "Vendor 1" },
        { id: "2", name: "Vendor 2" },
        { id: "3", name: "Vendor 3" },
        { id: "4", name: "Vendor 4" },
        { id: "5", name: "Vendor 5" },
    ];


    const handleSubmit = (values) => {

        const payload = {
            maintenanceDate: values.maintenanceDate,
            expiryDate: values.expiryDate,
            scheduleMaintenanceDate: values.scheduleMaintenanceDate,
            notes: values.notes,
            assignVendor: values.assignVendor,
        }
        setFormData((prevFormData) => ({
            ...prevFormData,
            maintenanceWarranty: values,
        }));

        setSelectedForm("5");
        console.log("payload data from maintenance", payload);
        addAssetFunctionMutate(formData);
    };
    const handleBack = () => {
        setSelectedForm("3");
    }

    return (
        <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, setFieldValue, errors, touched }) => (
                <Form>
                    <ModalSubHeading>Step 4</ModalSubHeading>
                    <ModalHeading>Expiry/Warranty Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>

                            <InputGroup>
                                <Label htmlFor="expiryDate">Expiry Date *</Label>
                                <FieldWrappers>
                                    <CalendarIcon />
                                    <input
                                        type="date"
                                        id="expiryDate"
                                        onChange={(e) => {
                                            setFieldValue("expiryDate", e.target.value);
                                        }}
                                        value={values.expiryDate}
                                        className="pl-6"
                                    />
                                </FieldWrappers>
                                {errors.expiryDate && touched.expiryDate && (
                                    <ErrorText>{errors.expiryDate}</ErrorText>
                                )}
                            </InputGroup>

                            <CombineInputGroup>
                                <InputGroup>
                                    <Label htmlFor="maintenanceDate">Last Maintenance Date </Label>
                                    <FieldWrappers>
                                        <CalendarIcon />
                                        <input
                                            type="date"
                                            id="maintenanceDate"
                                            onChange={(e) => {
                                                setFieldValue("maintenanceDate", e.target.value);
                                            }}
                                            value={values.maintenanceDate}
                                            className="pl-6"
                                        />
                                    </FieldWrappers>
                                </InputGroup>
                                <InputGroup>
                                    <Label htmlFor="scheduleMaintenanceDate">Next Maintenance Date </Label>
                                    <FieldWrappers>
                                        <CalendarIcon />
                                        <input
                                            type="date"
                                            id="scheduleMaintenanceDate"
                                            onChange={(e) => {
                                                setFieldValue("scheduleMaintenanceDate", e.target.value);
                                            }}
                                            value={values.scheduleMaintenanceDate}
                                            className="pl-6"
                                        />
                                    </FieldWrappers>
                                </InputGroup>

                            </CombineInputGroup>
                            <InputGroup>
                                <Label htmlFor="notes">Maintenance Notes </Label>

                                <Field
                                    as={Textarea}
                                    id="notes"
                                    name="notes"
                                    rows={4}
                                    placeholder="Enter Maintenance Notes"
                                />

                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="assignVendor">Assign Vendor For Maintenance </Label>
                                <Select
                                    id="assignVendor"
                                    name="assignVendor"
                                    className="w-full px-2"
                                    onChange={(e) => {
                                        setFieldValue("assignVendor", e.target.value);
                                    }}
                                    value={values.assignVendor}

                                >
                                    <MenuItem value="" disabled>Select Vendor</MenuItem>
                                    {vendorList.map((vendor) => (
                                        <MenuItem key={vendor.id} value={vendor.id}
                                        >
                                            {vendor.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </InputGroup>
                            <div className="flex items-end justify-end -mt-2">
                                <Vendor type="button" onClick={() => {
                                    // setIsShowAddExpenses(false);
                                    // setIsAddVendor(true);

                                }}><FaUserPlus className="mr-1 mt-0.5"
                                    />Add Vendor</Vendor>
                            </div>


                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={handleBack}>
                            Back
                        </SideCancelBtn>
                        <SubmitBtn type="submit">
                            Next
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const CombineInputGroup = tw.div`w-full flex md:flex-row flex-col space-x-4 items-end`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-500 font-normal mb-1.5`;



export default MaintenanceWarranty;